"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpersonationBanner = void 0;
const react_1 = __importStar(require("react"));
const fa_1 = require("react-icons/fa");
const Button_1 = require("./Button");
function ImpersonationBanner({ userEmail, logOutFn, }) {
    const [bannerHeight, setBannerHeight] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        var _a;
        setBannerHeight(((_a = document === null || document === void 0 ? void 0 : document.querySelector('#impersonation-banner')) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0);
        const handleResize = () => {
            var _a;
            setBannerHeight(((_a = document === null || document === void 0 ? void 0 : document.querySelector('#impersonation-banner')) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0);
        };
        window.addEventListener('resize', handleResize);
    }, []);
    return (react_1.default.createElement("div", { id: "impersonation-banner-wrap", className: "relative w-full", style: { height: bannerHeight + 'px' } },
        react_1.default.createElement("div", { id: "impersonation-banner", className: "bg-[#ffee86] fixed text-gray w-full pl-4 pr-24 md:px-24 z-50" },
            react_1.default.createElement("p", { className: "max-w-screen-2xl mx-auto flex flex-wrap md:flex-nowrap items-center md:justify-center py-1.5 w-auto" },
                react_1.default.createElement("span", { className: "flex flex-row items-center" },
                    react_1.default.createElement("span", { "aria-hidden": true, className: "p-2 rounded-full inline-block bg-[#ffcc00] mr-2 " },
                        react_1.default.createElement(fa_1.FaExclamation, { className: "text-white" }))),
                react_1.default.createElement("span", { className: "font-semibold italic inline-block" }, "Reminder"),
                ' ',
                react_1.default.createElement("span", { className: "inline-block mx-4" },
                    "You are currently impersonating ",
                    userEmail),
                react_1.default.createElement(Button_1.Button, { variant: "white", size: "custom", className: "flex items-center font-sofia py-0 !px-2 font-semibold text-sm right-4 top-1/2", type: "button", onClick: logOutFn },
                    react_1.default.createElement("span", null, "Log Out"))))));
}
exports.ImpersonationBanner = ImpersonationBanner;
